// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input } from '@angular/core';

@Component({
  selector: 'e-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent {
  @Input() full = false;
}
